import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useSetUsersForGroup = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ userGroupId, users }) => {
      const result = await restClient({
        url: `${prefix}/user-groups/${userGroupId}/users`,
        method: 'patch',
        data: {
          userIds: users.map(user => user.id)
        }
      });
      return result;
    },
    onSuccess: (data, variables) => {
      // Invalidate and refetch related queries after successful update
      queryClient.invalidateQueries(['userGroups']);
    },
    onError: (error) => {
    }
  });
};
